/* ============================================================================
   BOUCLE DE RETOUR PROD — construction du retour 👍/👎 (bêta)
   ----------------------------------------------------------------------------
   Assemble l'enregistrement envoyé dans la table `feedback` : le cas complet,
   REJOUABLE hors-ligne (mêmes champs que les lots ai-runs-*.json du banc de
   fidélité). Pur et sans dépendance : testable unitairement — l'envoi
   (supabase.insert fire-and-forget) reste dans main.js.
   ========================================================================== */

/* Coupe les champs texte et borne la taille des JSON embarqués (une scène
   pathologique ne doit pas fabriquer une ligne d'1 Mo). */
const clip = (s, n) => (s == null ? null : String(s).slice(0, n));
function safeJson(value, maxChars) {
  if (value == null) return null;
  try {
    const s = JSON.stringify(value);
    if (s.length <= maxChars) return JSON.parse(s);
    return { _tronque: true, _taille: s.length };
  } catch (_) { return null; }
}

/* Scène ALLÉGÉE pour le rejeu : uniquement ce que les bancs consomment
   (players/actions/markers/zones), sans les champs de rendu volumineux. */
export function sceneSnapshot(scene) {
  if (!scene || typeof scene !== "object") return null;
  const pick = (arr, fields) => (Array.isArray(arr) ? arr.map((o) => {
    const out = {};
    for (const f of fields) if (o?.[f] != null) out[f] = o[f];
    return out;
  }) : []);
  return {
    sport: scene.sport || null,
    players: pick(scene.players, ["id", "role", "team", "x", "y"]),
    actions: pick(scene.actions, ["order", "type", "from", "to", "tox", "toy", "fromx", "fromy", "label"]),
    // ⚠️ `kind`, `w`, `h`, `n` SONT INDISPENSABLES (bug trouvé le 10/08). Sans
    // eux, un agrès enregistré devient `{type:"agres"}` sans espèce : à la
    // relecture d'un lot de 👎, une poutre parfaitement dessinée ressemble à un
    // marqueur vide, et l'analyse conclut à tort que le correctif n'a pas
    // fonctionné — c'est exactement l'erreur que j'ai commise. Même problème
    // pour la COTE, dont l'orientation se lit dans `w`/`h`, pour le BUT
    // (dimensions) et pour la STATION numérotée (`n`).
    // L'instantané sert à REJOUER la scène : il doit porter ce qui la dessine.
    markers: pick(scene.markers, ["type", "x", "y", "label", "text", "kind", "w", "h", "n"]),
    zones: pick(scene.zones, ["x", "y", "w", "h", "label", "dim", "style"]),
  };
}

export function buildFeedbackRecord({ verdict, comment, prompt, sport, kind, route, corrected, analyse, scene, issues } = {}) {
  if (verdict !== "up" && verdict !== "down") return null;
  if (!prompt || !String(prompt).trim()) return null;
  return {
    verdict,
    comment: clip(comment && String(comment).trim() ? comment.trim() : null, 280),
    prompt: clip(prompt, 2000),
    sport: clip(sport, 40),
    kind: clip(kind, 20),
    route: clip(route, 30),
    corrected: !!corrected,
    famille: clip(analyse?.famille, 30) || null,
    analyse: safeJson(analyse, 20000),
    scene: safeJson(sceneSnapshot(scene), 20000),
    issues: safeJson(Array.isArray(issues) && issues.length ? issues : null, 4000),
  };
}
